import { CollectionHelpers } from 'src/helpers/CollectionHelpers';
import useSWR from 'swr';

import { Team } from 'models';
import { CreditHelpers } from 'helpers/CreditHelpers';
import { getCreditProgressColor, getCreditStatus } from 'helpers/credit-status';

import { TeamService } from 'services/TeamService';

export const useCreditBalanceDetails = (team?: CollectionOrId<Team> | null) => {
    const id = CollectionHelpers.id(team);
    const key = id ? CreditHelpers.swr.creditBalanceDetails(id) : null;

    const { data: creditBalanceInfo, isLoading } = useSWR(
        key,
        () => {
            return TeamService.getCreditBalanceDetails(id!);
        },
        {
            refreshInterval: 15 * 1000,
            shouldRetryOnError: false,
        },
    );

    if (!creditBalanceInfo) {
        return { creditBalanceInfo: undefined, isLoading };
    }

    const { currentTotal: total, currentBalance: balance, monthlyUsage, usage } = creditBalanceInfo;

    const ratio = total > 0 ? balance / total : 0;
    const remainingPercent = Math.round(ratio * 100);
    const status = getCreditStatus(remainingPercent);
    const color = getCreditProgressColor(status);

    return {
        creditBalanceInfo: {
            remainingPercent,
            status,
            color,
            balance,
            monthlyUsage,
            usage,
        },
        isLoading,
    };
};
